import React, { useMemo } from 'react';
import SubPage, { PageActions } from '#/common/components/SubPage';
import Findings from '../components/Findings';
import { useSearchParams } from 'react-router-dom';
import { PageAction } from '#/app/providers/PageProvider';
import type { Filter } from '#/common/components/DataGrid';

const FindingsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const assetId = searchParams.get('assetId') || undefined;
  const tenantIdFromParams = searchParams.get('tenantId') || undefined;
  const findingTenantFilter = useMemo<Filter[] | undefined>(
    () => (tenantIdFromParams ? [['tenantId', '=', tenantIdFromParams]] : undefined),
    [tenantIdFromParams],
  );

  const actions = useMemo<PageAction[]>(
    () => [
      {
        id: 'new-finding',
        alwaysShow: true,
        type: 'button',
        props: {
          type: 'submit',
          icon: 'add',
          label: 'Create New Finding',
          responsive: true,
          path: assetId ? `/findings/new?assetId=${assetId}` : '/findings/new',
        },
      },
    ],
    [assetId],
  );

  return (
    <SubPage title="Findings" type="list">
      <PageActions actions={actions} />
      <Findings hideNewAction permanentFilters={findingTenantFilter} />
    </SubPage>
  );
};

export default FindingsPage;
